import { render, staticRenderFns } from "./FileMemberManage.vue?vue&type=template&id=c02ab7a2&scoped=true&"
import script from "./FileMemberManage.vue?vue&type=script&lang=ts&"
export * from "./FileMemberManage.vue?vue&type=script&lang=ts&"
import style0 from "./FileMemberManage.vue?vue&type=style&index=0&id=c02ab7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02ab7a2",
  null
  
)

export default component.exports